// Source: hikari-frontend@4dd9568. Keep business facts here; never infer stock or currency.
export const product = {
  id: 'hikari-black-gi',
  name: 'The Hikari Gi',
  fullName: 'Men’s Brazilian Jiu-Jitsu Gi',
  priceLabel: '$120',
  color: 'Black with red detailing',
  material: '100% pearl weave',
  description: 'Your training deserves your full attention. Meet our flagship black jiu-jitsu gi: pearl weave construction, signature red detailing, and the essentials you came for.',
  sizes: [{
    name: 'A1',
    description: 'Small',
    checkoutUrl: 'https://buy.stripe.com/dR6aEY2wOgKU7EA28k'
  }, {
    name: 'A2',
    description: 'Medium',
    checkoutUrl: 'https://buy.stripe.com/8wM4gAfjA1Q0gb66oB'
  }, {
    name: 'A3',
    description: 'Large',
    checkoutUrl: 'https://buy.stripe.com/6oE6oIc7o7akcYU3cq'
  }, {
    name: 'A4',
    description: 'Extra large',
    checkoutUrl: 'https://buy.stripe.com/14kbJ2c7ocuEe2YaET'
  }],
  questions: [{
    question: 'What is the Hikari gi made from?',
    answer: 'The Hikari gi features 100% pearl weave construction and comes in black with red Hikari detailing.'
  }, {
    question: 'Which sizes are available?',
    answer: 'The men’s gi comes in A1 (small), A2 (medium), A3 (large), and A4 (extra large). These are size labels; body measurements are not currently listed.'
  }, {
    question: 'How do I order?',
    answer: 'Choose your size and continue to Stripe checkout. Review the final price, currency, and delivery details there before paying.'
  }]
};
